import type React from 'react';

// import { ErrorGlobal } from '@xing-com/content-error';

import * as Styled from './page-error.styles';

type PageErrorProps = {
  errorCode?: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PageError: React.FC<PageErrorProps> = ({ errorCode = '503' }) => {
  return (
    <Styled.Container>
      {/* <Status key={errorCode} code={parseInt(errorCode)} /> */}
      {/* <ErrorGlobal type={errorCode} /> */}
    </Styled.Container>
  );
};
export { PageError };
